import { createSlice } from "@reduxjs/toolkit";

const stoneSlice = createSlice({
    name:"stones",
    initialState:{
        stones:null
    },
    reducers:{
        setStoneList(state,action){
            state.stones = action?.payload;
        },
    }
})


export const {setStoneList} = stoneSlice.actions
export default stoneSlice.reducer